import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/portal-img.png'


const _hoisted_1 = { class: "portal" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-base font-extrabold" }

import HeaderPanel from '@/views/layouts/panel/HeaderPanel.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const listPortalMenu = [
  { id: 0, name: 'HJeX Agen', img: require('@/assets/img/portal-img/hjex-agen.png') },
  { id: 1, name: 'HJ Penumpang', img: require('@/assets/img/portal-img/hjp-bus.png') },
  { id: 2, name: 'HRD', img: require('@/assets/img/portal-img/hjp-hrd.png') },
  { id: 3, name: 'Paket HJeX', img: require('@/assets/img/portal-img/hjex-truck.png') },
  { id: 4, name: 'HJP Kiosk', img: require('@/assets/img/portal-img/hjp-wallet.png') },
  { id: 5, name: 'HJeX Self Order', img: require('@/assets/img/portal-img/hjex-order.png') }
]

const toPageAct = (val: any) => {
  switch (val) {
    case 0:
      // window.location.href = '/hrd'
      break
    case 1:
      // window.location.href = '/hrd'
      break
    case 2:
      window.location.href = '/hrd'
      break
    case 3:
      // window.location.href = '/hrd'
      break
    case 4:
      // window.location.href = '/hrd'
      break
    case 5:
      // window.location.href = '/hrd'
      break
    default:
      break
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderPanel),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "hj"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listPortalMenu, (list, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "card-menu",
              onClick: ($event: any) => (toPageAct(list.id))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: list.img,
                  class: "mx-auto"
                }, null, 8, _hoisted_7),
                _createElementVNode("p", _hoisted_8, _toDisplayString(list.name), 1)
              ])
            ], 8, _hoisted_5)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})